import { Routes } from '@angular/router';

/* // Asegurar que window esté disponible para TypeScript
declare const window: Window & typeof globalThis; */

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'client-creation',
    loadComponent: () => import('./client-creation/client-creation.page').then( m => m.ClientCreationPage)
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.page').then( m => m.DashboardPage)
  },
  {
    path: 'leads',
    loadComponent: () => import('./leads/leads.page').then( m => m.LeadsPage)
  },
];
